// extracted by mini-css-extract-plugin
export default {"sidebar":"IntegrationSidebar_sidebar__W5OeB","sidebar__wrapper":"IntegrationSidebar_sidebar__wrapper__x1iJy"};